var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list-item",
    {
      staticClass: "result-question-group",
      class: _vm.newClass,
      on: { click: _vm.showDetail },
    },
    [
      _c(
        "v-layout",
        { staticClass: "center-layout" },
        [
          _c(
            "v-flex",
            { attrs: { xs1: "" } },
            [
              _vm.currentQuestion.test
                ? [
                    _vm.exam.autoDiagnosisEnabled || _vm.isPass
                      ? _c("v-icon", { attrs: { color: "blue" } }, [
                          _vm._v("check"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isNotFullScore
                      ? _c("v-icon", { attrs: { color: "green" } }, [
                          _vm._v("change_history"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isNotPass
                      ? _c("v-icon", { attrs: { color: "red" } }, [
                          _vm._v("close"),
                        ])
                      : _vm._e(),
                  ]
                : [
                    _c("v-icon", { attrs: { color: "blue" } }, [
                      _vm._v("check"),
                    ]),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { class: _vm.exam.autoDiagnosisEnabled ? "xs11" : "xs9" },
            [
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "v-flex",
                    { staticClass: "align-center d-flex", attrs: { xs3: "" } },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "text-align-left ms-4 my-0",
                          class: { "gray-text": _vm.item.color == "gray" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.title) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs9: "" } },
                    [
                      _vm.questionCount === 1
                        ? _c("div", { staticClass: "question-header-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.currentQuestion.headerTitle) +
                                "\n            "
                            ),
                            _vm.groupScoreHistorySummary &&
                            _vm.currentQuestion.isTestQuestion &&
                            !_vm.exam.autoDiagnosisEnabled
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-start gray-text text-size-tiny mt-1",
                                  },
                                  [
                                    _vm._v(
                                      "\n              正解率" +
                                        _vm._s(
                                          _vm.groupScoreHistorySummary.rate
                                        ) +
                                        "%(" +
                                        _vm._s(
                                          _vm.groupScoreHistorySummary
                                            .successCount
                                        ) +
                                        "/" +
                                        _vm._s(
                                          _vm.groupScoreHistorySummary
                                            .totalCount
                                        ) +
                                        ")\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item.questions.length > 1 && _vm.currentQuestion.test
                        ? _c("SlideBar", {
                            attrs: {
                              current: _vm.correctCount,
                              total: _vm.item.questions.length,
                              align: "left",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          !_vm.exam.autoDiagnosisEnabled
            ? _c("v-flex", { attrs: { xs2: "" } }, [
                _vm.item.isTest
                  ? _c("div", { staticClass: "question-score" }, [
                      _vm._v(_vm._s(_vm.score) + " / " + _vm._s(_vm.maxScore)),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }